import { Col, Row, Stack } from "react-bootstrap"
import { Product } from "../../../../data/ecommerce/storeCatalog"
import ProductGallery from "./ProductGallery"
import DescTag from "../../../base/Tags/DescTag"
import { currencyFormat, formatHashtag } from "../../../../helpers/utils"

const ProductDescription = ({ product, category }: { product: Product; category: string }) => {
  const {
    name,
    unitPrice,
    unitType,
  //  colorStyle,
    description,
   // unitCrossedPrice,
    images,
    hashtags,
  } = product;

  return (
    <Row className="g-5">
      <Col xs={12} lg={7}>
        <ProductGallery images={images.map(x => x.imageId) || []} />
      </Col>
      <Col xs={12} lg={5}>
        <Stack className="justify-content-between h-100">
          <div
            className="mb-3 container-small text-start"
          >
            <h3 className="mb-8 lh-sm">{name}</h3>
            <h5 className="mb-4">{description}</h5>
            <div
              style={{ color: '#525B75' }}
              className="section-bg fw-medium text-category-gray fs-9 py-0 px-2 mb-1"
            >
              {category}
            </div>
            <div className="">
              {hashtags.map((tag, index) => (
                <DescTag fontSize="12.8px" key={index}  description={formatHashtag(tag)}  />
              ))}
            </div>
            <div className="d-flex flex-wrap align-items-center pt-5">
              <h1 className="me-2">{currencyFormat(unitPrice)}</h1> <h3> / {unitType} </h3>
              {/* {unitCrossedPrice && (
                <p className="text-500 text-decoration-line-through fs-6 mb-0 me-3">
                  {currencyFormat(unitCrossedPrice)}
                </p>
              )} */}
            </div>
          </div>
        </Stack>
      </Col>
    </Row>
  )
}

export default ProductDescription
